<main class="hm-main-wrapper">
    <router-outlet (activate)="onActivate($event)"></router-outlet>
</main>